<template>
    <index-table
        :cols="[
            {
                value: 'version',
                label: 'Version',
                sortable: true,
                searchable: true,
            },
            {
                value: 'description',
                label: 'Description',
                sortable: false,
                searchable: true,
            },
            {
                value: 'protocol',
                label: 'Protocol',
                sortable: true,
                searchable: true,
            },
            {
                value: 'is_premium',
                label: 'Premium',
                filter: 'convertBoolean',
                searchable: true,
                sortable: false,
            },
            {
                value: 'release_date',
                label: 'Release Date',
                sortable: true,
                searchable: true,
            },
            {
                value: 'created_at',
                label: 'Uploaded',
                sortable: true,
                searchable: false,
                filter: 'whenFromNow',
            },
        ]"
        :defaultSort="defaultSort"
        :defaultDir="defaultDir"
        :title="'Firmware'"
        :model="'firmware'"
        :createText="'Upload Firmware'"
        :options="['editable', 'deletable']"
        data-test-id="firmware-table"
    />
</template>

<script>
import IndexTable from '@/components/IndexTable/index.vue'
import SortDirections from '@/constants/sort-directions'

export default {
    components: {
        IndexTable,
    },
    data() {
        return {
            defaultSort: 'created_at',
            defaultDir: SortDirections.DESC,
        }
    },
}
</script>
